// Business info for KitchenBox
export const BUSINESS = {
  name: "KitchenBox",
  logo: "/kitchenbox-logo.png",
  tagline: "Fresh food, fresh meat.",
  cuisine: "Authentic Iraqi & Middle Eastern",
  city: "Charlottesville, VA",
  serviceArea: "Serving Charlottesville, VA & nearby areas",
  hours: "Daily · 11:00 AM – 9:00 PM",
  phone: "(434) 260-9120",
  phoneRaw: "14342609120",
  instagram: "kitchennbox",
  instagramUrl: "https://instagram.com/kitchennbox",
  instagramWidgetUrl: "",
  facebookUrl: "https://www.facebook.com/people/KitchenBox/100031883513470/",
  telegram: "+1 (434) 260-4421",
  telegramUrl: "https://t.me/+14342604421",
  cashApp: "$Ibrahim20002",
  cashAppUrl: "https://cash.app/$Ibrahim20002",
  applePay: "434-260-9120",
  advanceNotice: "Please place your order at least 2 days in advance.",
  cateringNotice: "For catering — parties & weddings — please order at least 1 week ahead.",
};

export const CATEGORIES = [
  { key: "mains", label: "Mains" },
  { key: "grills", label: "Grills" },
  { key: "sides", label: "Sides & Bread" },
  { key: "desserts", label: "Desserts" },
  { key: "drinks", label: "Drinks" },
];
